import { render, staticRenderFns } from "./Calculation.vue?vue&type=template&id=b256ba8a"
import script from "./Calculation.vue?vue&type=script&lang=js"
export * from "./Calculation.vue?vue&type=script&lang=js"
import style0 from "./Calculation.vue?vue&type=style&index=0&id=b256ba8a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports